import type { ReactElement } from 'react';
import { useCallback } from 'react';
import { t } from '@fetmode/i18n';
import { Button } from '@fetmode/ui';

import { ComplianceBadges } from './ComplianceBadges.js';
import './AgeEntryGate.css';

const EXIT_URL = 'https://www.google.com/';

export interface AgeEntryGateProps {
  onAccepted: () => void;
}

export function AgeEntryGate({ onAccepted }: AgeEntryGateProps): ReactElement {
  const handleAccept = useCallback(() => {
    onAccepted();
  }, [onAccepted]);

  const handleExit = useCallback(() => {
    window.location.assign(EXIT_URL);
  }, []);

  return (
    <div className="age-entry-gate" role="dialog" aria-modal="true" aria-labelledby="age-entry-title">
      <div className="age-entry-gate__backdrop" aria-hidden />
      <div className="age-entry-gate__panel">
        <div className="age-entry-gate__badge" aria-hidden>
          18+
        </div>
        <p className="age-entry-gate__notice">{t('common.compliance.ageEntryNotice')}</p>
        <h1 id="age-entry-title" className="age-entry-gate__title">
          {t('common.compliance.ageEntryTitle')}
        </h1>
        <div className="age-entry-gate__terms">
          <p>{t('common.compliance.ageEntryBody')}</p>
          <ul>
            <li>{t('common.compliance.ageEntryAffirm1')}</li>
            <li>{t('common.compliance.ageEntryAffirm2')}</li>
            <li>{t('common.compliance.ageEntryAffirm3')}</li>
          </ul>
        </div>
        <p className="age-entry-gate__warning">{t('common.compliance.ageEntryWarning')}</p>
        <div className="age-entry-gate__actions">
          <Button label={t('common.compliance.ageEntryExit')} variant="ghost" onClick={handleExit} />
          <Button label={t('common.compliance.ageEntryAgree')} onClick={handleAccept} />
        </div>
        <div className="age-entry-gate__footer">
          <ComplianceBadges />
        </div>
      </div>
    </div>
  );
}
